<template>
	<div
		class="flex w-auto items-center justify-between rounded-full bg-blue-500 px-4 text-white"
		:class="{ 'bg-red-500': isHovered, 'hover:bg-blue-600': !isHovered }"
	>
		<p class="px-2 py-1 text-sm">
			<span class="mr-1 font-bold uppercase">{{ label }}:</span>{{ value }}
		</p>
		<span
			class="fa-light fa-close ml-2"
			@mouseover="isHovered = true"
			@mouseleave="isHovered = false"
			@click="$emit('remove')"
		></span>
	</div>
</template>

<script>
export default {
	props: {
		label: String,
		value: [String, Number]
	},
	emits: ['remove'],
	data() {
		return {
			isHovered: false
		}
	}
}
</script>
